import React from "react";
import styles from "../../../Styles/Modules/PaytableItem.module.scss";
import Image from "../../../Elements/Image/Image";
import { useSelector } from "react-redux";

const PaytableItem = ({ symbol, paytableValues }) => {
  const { bet, currency } = useSelector((state) => state.game);
  const symbolSrc = `symbols/sym${String(symbol).padStart(2, "0")}.png`; // Generating symbol file name

  return (
    <div className={styles.paytableItem}>
      <div className={styles.paytableItemImage}>
        <Image src={symbolSrc} alt={`Symbol ${symbol}`} />
      </div>

      <ul className={styles.paytableItemList}>
        {paytableValues.map(
          (value, index) =>
            value !== 0 && (
              <li className={styles.paytableItemListItem} key={index}>
                <span className={styles.paytableItemListItemCount}>
                  x{index + 1}
                </span>

                <span className={styles.paytableItemListItemValue}>
                  {bet * value}
                </span>

                <span className={styles.paytableItemListItemCurrency}>
                  {currency}
                </span>
              </li>
            )
        )}
      </ul>
    </div>
  );
};

export default PaytableItem;
